export const ACTION_TYPES = {
  // User actions
  SET_USER: "SET_USER",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",

  // Language and localization
  SET_LANGUAGE: "SET_LANGUAGE",

  // Location
  SET_CURRENT_LOCATION: "SET_CURRENT_LOCATION",

  // UI state
  SET_LOADING: "SET_LOADING",
  SET_ERROR: "SET_ERROR",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_INITIALIZED: "SET_INITIALIZED",
  SET_IS_LOADING: "SET_IS_LOADING",

  // Notifications
  ADD_NOTIFICATION: "ADD_NOTIFICATION",
  REMOVE_NOTIFICATION: "REMOVE_NOTIFICATION",

  // Fields
  UPDATE_FIELD: "UPDATE_FIELD",
  ADD_FIELD: "ADD_FIELD",
  DELETE_FIELD: "DELETE_FIELD",

  // Chat
  ADD_CHAT_MESSAGE: "ADD_CHAT_MESSAGE",
  CLEAR_CHAT_HISTORY: "CLEAR_CHAT_HISTORY",

  // Settings
  UPDATE_SETTINGS: "UPDATE_SETTINGS",

  // Devices
  UPDATE_DEVICE_STATUS: "UPDATE_DEVICE_STATUS",
  ADD_DEVICE: "ADD_DEVICE",
  REMOVE_DEVICE: "REMOVE_DEVICE",

  // Disease detection
  ADD_DISEASE_RESULT: "ADD_DISEASE_RESULT",

  // Weather
  UPDATE_WEATHER: "UPDATE_WEATHER",
};
